export const GET_LIST_ORDER = 'GET_LIST_ORDER';
export const GET_DETAIL_ORDER = 'GET_DETAIL_ORDER';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';


